import { useEffect, useState } from 'react'

export type Breakpoint = 'phone' | 'tablet' | 'desktop'

function bpFromWidth(w: number): Breakpoint {
  return w < 768 ? 'phone' : w < 1024 ? 'tablet' : 'desktop'
}

/**
 * Returns the current breakpoint based on `window.innerWidth`.
 *  - `phone`  : width < 768px
 *  - `tablet` : 768px <= width < 1024px
 *  - `desktop`: width >= 1024px
 *
 * Falls back to `desktop` when `window` is not defined (SSR / non-browser).
 * Updates on the `resize` event.
 */
export function useBreakpoint(): Breakpoint {
  const [bp, setBp] = useState<Breakpoint>(() => {
    if (typeof window === 'undefined') return 'desktop'
    return bpFromWidth(window.innerWidth)
  })

  useEffect(() => {
    const onResize = (): void => setBp(bpFromWidth(window.innerWidth))
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  return bp
}
